import React, { useState } from 'react';
import { FaCopy, FaCheck } from 'react-icons/fa';
import { toast } from 'react-toastify';
import './Contact.css';

const EMAIL = 'supportswingsetupai@gmail.com';

const Contact: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(EMAIL);
    setCopied(true);
    toast.success('Email copied to clipboard!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Header Section */}
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>We're here to help you with any questions or concerns</p>
        </div>

        {/* Contact Card */}
        <div className="contact-card">
          <div className="contact-icon-wrapper">
            <span className="contact-main-icon">📧</span>
          </div>

          <h2>Get In Touch</h2>

          <p className="contact-description">
            Have questions about our screeners, need help with your subscription,
            or want to share feedback? We'd love to hear from you! Reach out to us
            and our team will get back to you as soon as possible.
          </p>

          <div className="contact-email-box">
            <span className="email-icon">✉️</span>
            <a href={`mailto:${EMAIL}`} className="email-link">
              {EMAIL}
            </a>
            <button
              className="copy-btn"
              onClick={handleCopy}
              title={copied ? 'Copied!' : 'Copy email'}
            >
              {copied ? <FaCheck size={14} /> : <FaCopy size={14} />}
            </button>
          </div>

          <div className="contact-info-list">
            <div className="info-item">
              <span className="info-icon">⏰</span>
              <span>We typically respond within 24 hours</span>
            </div>
            <div className="info-item">
              <span className="info-icon">💬</span>
              <span>Available for queries related to subscriptions, features & support</span>
            </div>
          </div>
        </div>

        {/* Quick Help Section */}
        <div className="quick-help-section">
          <h3>Looking for quick answers?</h3>
          <p>Check out our FAQ section for commonly asked questions</p>
          <a href="/faq" className="faq-link">
            Visit FAQ →
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
